export default "__VITE_ASSET__CkXjXNsm__ 1920w";